import React from "react";

export default function ArticleCardBody({ children }) {
  return <div className="w-full relative">{children}</div>;
}



// WEBPACK FOOTER //
// ./src/ArticleCardBody/ArticleCardBody.js